<template>
  <svg
    width="26"
    height="19"
    viewBox="0 0 88 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_399_298)">
      <path
        d="M40.4079 3.62721C41.6053 -0.0580342 46.8189 -0.0580244 48.0163 3.62722L55.2949 26.0282C55.8304 27.6763 57.3662 28.7921 59.0991 28.7921L82.6529 28.7921C86.5278 28.7921 88.1389 33.7506 85.004 36.0282L65.9486 49.8728C64.5466 50.8914 63.96 52.6968 64.4955 54.3449L71.774 76.7459C72.9714 80.4311 68.7535 83.4956 65.6187 81.218L46.5633 67.3735C45.1613 66.3549 43.2629 66.3549 41.861 67.3735L22.8056 81.218C19.6707 83.4956 15.4528 80.4311 16.6502 76.7459L23.9287 54.3449C24.4642 52.6968 23.8776 50.8914 22.4756 49.8728L3.4202 36.0282C0.285342 33.7506 1.89645 28.7921 5.77134 28.7921L29.3251 28.7921C31.058 28.7921 32.5939 27.6763 33.1294 26.0282L40.4079 3.62721Z"
        fill="#DBDBDB"
      />
      <g clip-path="url(#clip1_399_298)">
        <path
          d="M40.4079 3.62721C41.6053 -0.0580342 46.8189 -0.0580244 48.0163 3.62722L55.2949 26.0282C55.8304 27.6763 57.3662 28.7921 59.0991 28.7921L82.6529 28.7921C86.5278 28.7921 88.1389 33.7506 85.004 36.0282L65.9486 49.8728C64.5466 50.8914 63.96 52.6968 64.4955 54.3449L71.774 76.7459C72.9714 80.4311 68.7535 83.4956 65.6187 81.218L46.5633 67.3735C45.1613 66.3549 43.2629 66.3549 41.861 67.3735L22.8056 81.218C19.6707 83.4956 15.4528 80.4311 16.6502 76.7459L23.9287 54.3449C24.4642 52.6968 23.8776 50.8914 22.4756 49.8728L3.4202 36.0282C0.285342 33.7506 1.89645 28.7921 5.77134 28.7921L29.3251 28.7921C31.058 28.7921 32.5939 27.6763 33.1294 26.0282L40.4079 3.62721Z"
          fill="#f6a61e"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_399_298">
        <rect width="88" height="87" fill="white" />
      </clipPath>
      <clipPath id="clip1_399_298">
        <rect
          width="53"
          height="90"
          fill="white"
          transform="translate(-10 -3)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
